<script lang="ts">
  interface Props {
    library_video: LibraryVideoType
    onViewVideo: (library_video: LibraryVideoType) => void
  }
  let props = $props()

  let { library_video, onViewVideo } = props

  import play_icon from "@images/university/play-icon.png"
</script>

<button
  type="button"
  onclick={() => onViewVideo(library_video)}
  class="video rounded shadow-xl hover:border w-72 border-blue-400 hover:cursor-pointer overflow-hidden text-left p-0"
  aria-label={`View video: ${library_video.title}`}
>
  <div class="relative">
    <img
      src={play_icon}
      class="absolute inset-0 opacity-50 hover:opacity-100 z-30"
      alt="Play"
    />
    <div class="absolute inset-0 bg-gray-700 opacity-70 z-10"></div>

    <img
      src={library_video.thumbnail_url}
      class="object-fill w-full"
      alt={library_video.title}
    />
  </div>
  <div class="bg-black py-1 px-4 w-full opacity-100">
    <p
      class="text-white text-sm text-center overflow-hidden whitespace-nowrap text-ellipsis w-full"
    >
      {library_video.title}
    </p>
  </div>
</button>

<style>
  .video {
    -webkit-transition: 250ms all;
    transition: 250ms all;
  }
  .video:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    z-index: 1;
  }
</style>
